// UiSelect.jsx
import React from 'react'
import './UiSelect.css'
import styled from 'styled-components'

export default function UiSelect({
  label,
  value,
  onChange,
  options,
  required = false,
  errorMessage = '',
  verified = false,
  onVerifiedChange = () => {},
  placeholder = 'Select',
  disabled = false,
  name,
  id,
  className = '',
  showCheckbox = false,
  readOnly = false,
  onFocus = () => {},
  onBlur = () => {}
}) {
  return (
    <div className={`input-group cig ${className}`}>
      {label ? (
        <label style={{ color: '#333333' , fontSize: '12px' }}>
          {label} {required && !value && <span className="starik">*</span>}
          {errorMessage ? (
            <span className="redtext">{errorMessage}</span>
          ) : null}
        </label>
      ) : null}

      <select
        className="form-select"
        aria-label={label || 'select'}
        name={name}
        id={id}
        value={value ?? ''}
        disabled={disabled}
        readOnly={readOnly}
        onChange={e => onChange?.(e.target.value, e)}
        onFocus={onFocus}
        onBlur={onBlur}
      >
        <option value="">{placeholder}</option>
        {Array.isArray(options) &&
          options.map(opt =>
            typeof opt === 'object' ? (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ) : (
              <option key={opt} value={opt}>
                {opt}
              </option>
            )
          )}
      </select>

      {showCheckbox && (
        <CheckboxContainer>
          <CheckboxInput
            type="checkbox"
            checked={verified}
            onChange={onVerifiedChange}
            disabled={disabled}
            readOnly={readOnly}
          />
          <Checkmark isChecked={verified} hasLabel={!!label} />
        </CheckboxContainer>
      )}
    </div>
  )
}

const CheckboxContainer = styled.label`
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 24px;
  height: 24px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 8; /* keep above select but below modals */
  pointer-events: none;
`

const CheckboxInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

const Checkmark = styled.span`
  position: absolute;
  top: ${props => (props.hasLabel ? '20px' : '1px')};
  right: 0;
  height: 24px;
  width: 24px;
  background-color: ${props => (props.isChecked ? '#d9e8c3' : '#fff')};
  pointer-events: auto;
  border-left: ${props =>
    props.isChecked ? 'none' : '6px solid #ccc !important'};
  border-top: ${props =>
    props.isChecked ? 'none' : '6px solid #ccc !important'};
  border-right: ${props =>
    props.isChecked ? 'none' : '6px solid #ccc !important'};
  border-bottom: ${props =>
    props.isChecked ? 'none' : '6px solid #ccc !important'};
  border: ${props => (props.isChecked ? 'none' : '6px solid #ccc')};

  &:after {
    content: '';
    position: absolute;
    display: ${props => (props.isChecked ? 'block' : 'none')};
    left: 8px;
    top: 6px;
    width: 6px;
    height: 10px;
    border: solid #69b55a;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`
